import _typeof from '@babel/runtime/helpers/typeof';
import { fusra } from '@ap/fus-reporting-api-js-v4';
import { getAnalytics, logEvent } from 'firebase/analytics';
import { getSessionId } from './helpers/getSessionId.js';
export { getSessionId } from './helpers/getSessionId.js';
export { getUserInfo } from './helpers/getUserInfo.js';
export { EventGroup } from './eventGroup.js';

var NODE_ENV;
try {
  ;
  NODE_ENV = process.env.NODE_ENV;
} catch (_unused) {
  console.error('cannot get value from process.env');
}
function createDispatch(app) {
  return function dispatch(data) {
    var eventId = data.eventId,
      groupId = data.groupId,
      groupVersion = data.groupVersion,
      eventData = data.eventData;
    if (typeof eventId !== 'string' || typeof groupId !== 'string' || typeof groupVersion !== 'number' || _typeof(eventData) !== 'object' && typeof eventData !== 'function') {
      console.error("Invalid params\neventId: ".concat(eventId, "\ngroupId: ").concat(groupId, "\ngroupVersion: ").concat(groupVersion, "\neventData: ").concat(eventData));
      return;
    }
    var sessionId = getSessionId();
    var eventDataConstructed = typeof eventData === 'function' ? eventData(data) : eventData;
    if (NODE_ENV === 'development') {
      console.debug("Event registered: ", {
        sessionId: sessionId,
        eventId: eventId,
        groupId: groupId,
        groupVersion: groupVersion,
        eventData: eventDataConstructed
      });
    }
    try {
      fusra('event', {
        sessionId: sessionId,
        eventId: eventId,
        groupId: groupId,
        groupVersion: groupVersion,
        eventData: eventDataConstructed
      });
    } catch (e) {
      console.error('fusra report error: ', e.message);
    }
    try {
      if (!app.options.measurementId) {
        console.warn('measurementId not configured, skip Firebase Analytics part');
        return;
      }
      var analytics = getAnalytics(app);
      logEvent(analytics, "".concat(groupId, ".").concat(eventId), eventDataConstructed);
    } catch (e) {
      console.error('firebase analytics report error: ', e.message);
    }
  };
}

export { createDispatch };
